export const PartnerId = "publisher-onboarding";

// Unique platform names that do not need localization
export const PlatformNames = {
  XboxSeriesXS: "Xbox Series X|S",
  XboxOne: "Xbox One",
  WindowsStore: "Windows Store",
  PC: "PC",
  Steam: "Steam",
  Epic: "Epic",
  NintendoSwitch: "Nintendo Switch",
  PS5: "PS5",
  PS4: "PS4",
  Android: "Android",
  iOS: "iOS",
  SonyPlaystation: "Sony Playstation",
  EpicStore: "Epic Store",
  Xbox: "Xbox",
};

export const EngineNames = {
  Unity: "Unity",
  UnrealEngine: "Unreal Engine",
  Godot: "Godot",
};

export const CrossVersionPlatformNames = {
  PS4: "PS4",
  PS5: "PS5",
  Switch: "Switch",
  Epic: "Epic",
  Steam: "Steam",
  Luna: "Luna",
  Android: "Android",
  iOs: "iOS",
  Xbox: "Xbox",
};
